module.exports = __webpack_public_path__ + "img/qb-logo.270cddf8.svg";